import React from 'react';
import styled from 'styled-components';

import { formatTimestamp } from '../utils';

interface DurationCellProps {
  duration: number;
}

export function DurationCell({ duration }: DurationCellProps) {
  return <DurationCellWrapper>{formatTimestamp(duration)}</DurationCellWrapper>;
}

const DurationCellWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 12px;
`;
